import { CatchError } from '@guildeducationinc/recess';

export const AppErrorBoundary: React.FC = ({ children }) => {
  return <CatchError>{children}</CatchError>;
};
